import { render, staticRenderFns } from "./ResetPasswordEmailPage.vue?vue&type=template&id=6c427ef9"
import script from "./ResetPasswordEmailPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordEmailPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports